import type { activityType } from "models/activity.model";

export enum StatusActivity {
  FINISHED = "finished",
  NOT_STARTED = "not_started",
  PENDING = "pending"
}

export const getMappedStatus = (status: string): StatusActivity => {
  switch (status) {
    case "finished_noeval":
      return StatusActivity.FINISHED;
    case "pending":
    case "started":
      return StatusActivity.PENDING;
    case "not_started":
      return StatusActivity.NOT_STARTED;
    default:
      return StatusActivity.NOT_STARTED;
  }
};

export const mergeActivities = (prev: activityType[], next: activityType[]) =>
  [...prev, ...next].filter(
    (item, index, self) =>
      self.findIndex(i => i.id === item.id) === index
  );